<template>
  <HPopup class="h-town-list"
          ref="popup"
          v-show="visible">
    <div class="popup-body">
      <CreateTown v-if="showCreateTown" @close="handleCloseCreateTown" @created="handleTownCreated">
      </CreateTown>
      <InitailTown v-else-if="!townList.length && !loading" @close="handleClose" @inited="handleTownInited">
      </InitailTown>
      <template v-else>
        <div class="hero-towns">
          <p class="popup-header">我的城镇</p>
          <div class="town-list flex">
            <div class="town-item h-bg brown-2 h-outer-border around-4 bz0 bw3"
                 v-for="(item, index) in townList">
              <div class="town-icon h-outer-border around-4 bz0 bw2">
                <img v-if="item.faction" :src="townUrl(item.faction)" alt="">
              </div>
              <div class="town-info">
                <p class="town-name white">{{ item.factionCn }}</p>
                <p class="town-level white">{{ item.level }}级城镇</p>
              </div>
              <div class="btns">
                <button v-click-sound-button
                        class="h-btn normal"
                        @click="handleEnter(index)">
                  进入
                </button>
              </div>
            </div>

            <div v-if="townList.length === 1" class="town-item h-bg brown-2 h-outer-border around-4 bz0 bw3">
              <div class="town-icon h-outer-border around-4 bz0 bw2">
              </div>
              <div class="town-info">
                <p class="town-name white">未建造</p>
                <p class="town-level white"></p>
              </div>
              <div class="btns">
                <button v-click-sound-button
                        class="h-btn normal"
                        @click="handleCreate()">
                  建立
                </button>
              </div>
            </div>
          </div>

          <div class="footer center">
            <button v-click-sound-button
                    class="h-btn cancel btn-border"
                    @click="handleClose">
            </button>
          </div>
        </div>
      </template>
    </div>
  </HPopup>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import FACTION_CONF from '@js/config/faction'
  import HPopup from '@/components/h-popup/index.vue'
  import InitailTown from './initial-town'
  import CreateTown from './create-town'

  export default {
    name: 'h-town-list',
    data () {
      return {
        FACTION_CONF,
        loading: false,
        showCreateTown: false,
      }
    },

    props: {
      visible: {
        type: Boolean,
        default: true
      },
      zIndex: {
        type: Number,
        default: 1000
      },
    },

    computed: {
      ...mapGetters('user', [
        'userInfo',
      ]),
      ...mapGetters('gameData', [
        'townList',
      ]),
    },

    async created () {
      try {
        this.loading = true
        await this.getTownList()
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },

    async mounted () {
      this.$refs.popup.$el.style.zIndex = this.zIndex
    },

    methods: {
      ...mapActions('gameData', [
        'getTownList'
      ]),

      handleClose () {
        this.$emit('close')
      },

      handleCloseCreateTown () {
        this.showCreateTown = false
      },

      townUrl (faction) {
        return `${this.$rHost}/img/common/race/${faction}.jpg`
      },

      handleTownInited () {
        this.getTownList()
      },

      handleTownCreated () {
        this.showCreateTown = false
        this.getTownList()
      },

      handleEnter (index) {
        this.$emit('enterTown', index)
      },

      handleCreate (index) {
        this.$message('暂未开放')
        // this.showCreateTown = true
      },
    },

    components: {
      HPopup,
      InitailTown,
      CreateTown,
    }
  }
</script>

<style lang="stylus" scoped>
  .hero-towns
    width 300px

  .town-list
    flex-direction column
    .town-item
      display flex
      justify-content space-between
      padding 4px
      margin-bottom 5px
      .town-info
        display flex
        align-items center
        letter-spacing 1px
      .town-name,
      .town-level
        padding 0 10px
        font-size 12px
      .btns
        display flex
        align-items center
        button
          width 51px
          height 24px
          font-size 12px

  .town-icon
    overflow hidden
    width 80px
    height 55px
    display flex
    justify-content center
    align-items center
    > img
      width 100%

  .footer
    margin-top 20px

</style>
